import { render, staticRenderFns } from "./AddFormToClientPage.vue?vue&type=template&id=bf339eb4"
import script from "./AddFormToClientPage.vue?vue&type=script&lang=js"
export * from "./AddFormToClientPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports